import muster from '@dbk-legacy/muster';
import { variable } from '@dbk-legacy/muster/helpers';
import { getValues } from '@dbk-legacy/muster/utils';
import { encode } from 'base-64';
import { Base64 } from 'js-base64';
import isValidJsonString from '../utils/is-valid-json-string';
import {API_RESPONSE_CODES,RM_REGION_UK,RM_REGION,EBANKINGWEBLUX } from '../constants';
import  envConfig  from '../../db-env-build';
import moment from 'moment';
import Guid from '../utils/guid';

export default () =>
  muster()
    
    .path('portfolio.getSummaryPageData', {
      call: async ({ req }, { get, set, call }) => {
      
        const [messages] = await getValues(get('i18n.messages'));
        const [result] = await getValues(get(`dashboard.summaryData`));
          isValidJsonString(result).then(async (data) => {
            if (data) {
              if (data.retCode === API_RESPONSE_CODES.SUCCESS && 
                data.portfolios && data.portfolios.length > 0) {
                  await Promise.all([
                    set('portfolio.summary', data),
                    set('dashboard.showSpinner', false)
                  ])
                  
              }
              else {
                  await Promise.all([
                    set('dashboard.errorMsg', messages['app.dataExports.genericError.message']),
                    set('dashboard.errorTitle', messages['app.dataExports.genericError.title']),
                    set('dashboard.showSpinner', false),
                    set('dashboard.showErrorModal', true)
                  ])
                }
            }
          }).catch(async (error) => {
            await Promise.all([
              set('dashboard.errorTitle', messages['app.dataExports.genericError.title']),
              set('dashboard.errorMsg', messages['app.dataExports.genericError.message']),
              set('dashboard.showSpinner', false),
              set('dashboard.showErrorModal', true)
    
            ])
          });
          if(envConfig.envConfig === EBANKINGWEBLUX)
          {
           await call('ais.getConsentRequest', {psuId: "RE123123"});
          }
      }
    })

    .path('dashboard.callSummaryAPI', {
      call: async ({ req }, { get, set, call }) => {
          await set('portfolio.summary', null);
          const [destinationCurrency, portfolioData] = await getValues(get(['userprofile.prefCurrency', 'app.user.selectedPortfolioData']));
          const request = {
            destinationCurrency,
            pfRelID: portfolioData.title
          }
          const guidStr = Guid();
          const inputParam = Base64.encode(JSON.stringify(request));
          const [dashboardData] = await getValues(get(`roster.data.portfolio.getSummaryPageData["${inputParam}"]["${guidStr}"]`));
          await set('dashboard.summaryData', dashboardData);
          await call('portfolio.getSummaryPageData');
          await set('userprofile.prevPrefCurrency',destinationCurrency);
      }
    })


    .path('dashboard.resetVariables', {
        call: async ({ req }, { get, set, call }) => {
            await set('portfolio.summary', null);
             //below condition is only for RM access WMCE-23470 & WMCE-24306 
             if(envConfig.rmRegion === RM_REGION_UK || envConfig.rmRegion === RM_REGION){
                await set('userprofile.prevPrefCurrency', null)
             }
        }
    })
    .path('dashboard.summaryData', variable(null))
    .path('portfolio.summary', variable(null))
    .path('dashboard.showSpinner', variable(false))
    .path('dashboard.showErrorModal', variable(false))
    .path('dashboard.errorTitle', variable(null))
    .path('dashboard.errorMsg', variable(null))

    